export const AdvisorConciergeHandoffPanel = ({ handoff, handoffPrepared, isPreparing, onPrepareHandoff, whatsappHref }) => {
  if (!handoff) return null;

  const hasWhatsAppCta = Boolean(whatsappHref);

  return (
    <div className="rounded-[24px] border border-[#D4AF37]/25 bg-white px-5 py-5 shadow-[0_12px_30px_rgba(0,25,53,0.08)]" data-testid="signature-advisor-concierge-handoff-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-concierge-handoff-eyebrow">Concierge handoff intelligence</p>
      <h4 className="mt-2 text-xl font-semibold text-[#001935]" data-testid="signature-advisor-concierge-handoff-headline">{handoff.headline}</h4>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-concierge-handoff-summary">{handoff.summary}</p>

      <div className="mt-4 rounded-[20px] border border-[#D4AF37]/20 bg-[#fffaf1] px-4 py-4" data-testid="signature-advisor-concierge-handoff-brief-preview">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">WhatsApp brief</p>
        <p className="mt-3 whitespace-pre-line text-sm leading-7 text-[#001935]" data-testid="signature-advisor-concierge-handoff-whatsapp-message">{handoff.whatsapp_message}</p>
      </div>

      <div className="mt-4 space-y-3" data-testid="signature-advisor-concierge-handoff-details">
        <div className="rounded-[18px] border border-[#D4AF37]/20 bg-[#FDFBF7] px-4 py-3" data-testid="signature-advisor-concierge-handoff-admin-context">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Admin follow-up brief</p>
          <p className="mt-2 text-sm leading-7 text-[#001935]">{handoff.admin_context}</p>
        </div>
        <div className="rounded-[18px] border border-[#001935]/10 bg-[#001935] px-4 py-3 text-white" data-testid="signature-advisor-concierge-handoff-recommended-action">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#D4AF37]">Recommended action</p>
          <p className="mt-2 text-sm leading-7 text-[#dbe4f0]">{handoff.recommended_action}</p>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-3" data-testid="signature-advisor-concierge-handoff-actions">
        <button
          className="rounded-[18px] bg-[#D4AF37] px-4 py-3 text-sm font-bold text-[#1A1A1A] transition hover:bg-[#c79f29] disabled:cursor-not-allowed disabled:opacity-60"
          data-testid="signature-advisor-concierge-handoff-prepare-button"
          disabled={isPreparing}
          onClick={onPrepareHandoff}
          type="button"
        >
          {isPreparing ? "Preparing handoff..." : handoffPrepared ? "Refresh concierge handoff" : "Prepare & log handoff"}
        </button>
        <a
          className={`rounded-[18px] border px-4 py-3 text-sm font-semibold transition ${
            hasWhatsAppCta ? "border-[#D4AF37]/35 bg-white text-[#8b6d16] hover:bg-[#fff4db]" : "pointer-events-none border-[#d8cfbb] bg-[#f4efe3] text-[#a79c84]"
          }`}
          data-testid="signature-advisor-concierge-handoff-whatsapp-button"
          href={whatsappHref || "#"}
          rel="noreferrer"
          target="_blank"
        >
          Continue with Agent on WhatsApp
        </a>
      </div>

      <div className="mt-3 grid gap-2 sm:grid-cols-2" data-testid="signature-advisor-concierge-handoff-steps">
        <div className="rounded-[16px] border border-[#D4AF37]/20 bg-[#FDFBF7] px-3 py-3" data-testid="signature-advisor-concierge-handoff-step-1">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#D4AF37] text-[11px] font-bold text-[#1A1A1A]">1</span>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8b6d16]">Prepare</p>
          </div>
          <p className="mt-2 text-xs leading-6 text-[#7a705d]">First click <strong>Prepare &amp; Log Handoff</strong> to save your current advisor context.</p>
        </div>

        <div className="rounded-[16px] border border-[#D4AF37]/20 bg-[#FDFBF7] px-3 py-3" data-testid="signature-advisor-concierge-handoff-step-2">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#001935] text-[11px] font-bold text-white">2</span>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8b6d16]">Continue</p>
          </div>
          <p className="mt-2 text-xs leading-6 text-[#7a705d]">Then send this to your agent on WhatsApp to resume instantly using your saved preferences.</p>
        </div>
      </div>
    </div>
  );
};